import { z } from 'zod';
export const STATS_MAX_RANGE_DAYS = 400;
export const STATS_GRANULARITIES = ['day', 'week', 'month'];
const statsDate = z.iso.date('Usá el formato AAAA-MM-DD');
function daysBetween(from, to) {
    return Math.round((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / 86_400_000);
}
/** Rango por fecha comercial, ambos extremos incluidos. Sin `from`/`to`: últimos 30 días. */
export const statsRangeQuerySchema = z
    .object({
    from: statsDate.optional(),
    to: statsDate.optional(),
})
    .refine((q) => !q.from || !q.to || q.from <= q.to, { message: '"from" tiene que ser anterior a "to"' })
    .refine((q) => !q.from || !q.to || daysBetween(q.from, q.to) < STATS_MAX_RANGE_DAYS, {
    message: `El rango no puede superar ${STATS_MAX_RANGE_DAYS} días`,
});
export const statsSeriesQuerySchema = z
    .object({
    from: statsDate.optional(),
    to: statsDate.optional(),
    granularity: z.enum(STATS_GRANULARITIES).default('day'),
})
    .refine((q) => !q.from || !q.to || q.from <= q.to, { message: '"from" tiene que ser anterior a "to"' })
    .refine((q) => !q.from || !q.to || daysBetween(q.from, q.to) < STATS_MAX_RANGE_DAYS, {
    message: `El rango no puede superar ${STATS_MAX_RANGE_DAYS} días`,
});
export const statsTopItemsQuerySchema = z
    .object({
    from: statsDate.optional(),
    to: statsDate.optional(),
    limit: z.coerce.number().int().min(1).max(100).default(10),
    orderBy: z.enum(['revenue', 'quantity']).default('revenue'),
})
    .refine((q) => !q.from || !q.to || q.from <= q.to, { message: '"from" tiene que ser anterior a "to"' })
    .refine((q) => !q.from || !q.to || daysBetween(q.from, q.to) < STATS_MAX_RANGE_DAYS, {
    message: `El rango no puede superar ${STATS_MAX_RANGE_DAYS} días`,
});
//# sourceMappingURL=stats.js.map